import { Component, OnInit } from '@angular/core';
import { BaseLeadsManagement } from '../../baseLidsManagment';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app-state.index';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { LoginService } from 'app/login/services/login.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';

@Component({
  selector: 'app-lids-managment-mobile',
  templateUrl: './lids-managment-mobile.component.html',
  styleUrl: './lids-managment-mobile.component.scss'
})
export class LidsManagmentMobileComponent extends BaseLeadsManagement implements OnInit {
    displaySidebar: boolean = false;

  constructor(public localizationService: LocalizationService,public loginService: LoginService,public  store: Store<AppState>, public commonService: CommonService,public businessManagmentService:BusinessManagmentService) {
     super(businessManagmentService,loginService,store,localizationService,commonService)
   }
   
  ngOnInit(): void {
    this.init();
    this.loadLids()
  }
}
